__turbopack_context__.v({
  "badges": "content-card-module-scss-module__sIjAaq__badges",
  "body": "content-card-module-scss-module__sIjAaq__body",
  "card": "content-card-module-scss-module__sIjAaq__card",
  "description": "content-card-module-scss-module__sIjAaq__description",
  "heading": "content-card-module-scss-module__sIjAaq__heading",
  "imageWrapper": "content-card-module-scss-module__sIjAaq__imageWrapper",
  "sideBySide": "content-card-module-scss-module__sIjAaq__sideBySide",
});
